<template>
  <v-dialog max-width="550" v-model="dialog.shows.showDetail">
    <v-card>
      <v-card-title>
        <div class="title">{{ $vuetify.lang.t(dialog.title) }}</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-list two-line>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-pound</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1"
                >{{ form.invoiceId }}
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.transfer.cols.invoiceId.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-bank</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1"
                >{{ form.accountNumber }}
              </v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t("$vuetify.transfer.cols.accountNumber.title")
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-apps</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1"
                >{{ form.application }}
              </v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t("$vuetify.transfer.cols.application.title")
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-cash</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1"
                >{{ form.amount }}
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.transfer.cols.amount.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <template v-if="form.status === 'SUCCESS'">
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="secondary">mdi-cash</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1"
                  >{{ _.round(form.amount + form.charges, 2) }}
                </v-list-item-title>
                <v-list-item-subtitle
                  >{{ $vuetify.lang.t("$vuetify.transfer.cols.amount.title2") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-transfer</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <v-chip
                  :color="getTypeColor(form.transaction)"
                  class="chip-list"
                  text-color="white"
                >
                  {{ form.transaction }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{
                  $vuetify.lang.t("$vuetify.transfer.cols.transaction.title")
                }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <template
            v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_COMPTA'])"
          >
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="secondary">mdi-transfer</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1"
                  >{{ form.operation }}
                </v-list-item-title>
                <v-list-item-subtitle
                  >{{
                    $vuetify.lang.t("$vuetify.transfer.cols.operation.title")
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-sticker</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1"
                >{{ form.reference }}
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.transfer.cols.reference.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <template v-if="$auth.check(['ROLE_ADMIN'])">
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="secondary">mdi-sticker</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1"
                  >{{ form.remoteReference }}
                </v-list-item-title>
                <v-list-item-subtitle
                  >{{
                    $vuetify.lang.t(
                      "$vuetify.transfer.cols.remoteReference.title"
                    )
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-flag</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1">
                <v-chip
                  :color="getStatusColor(form.status)"
                  class="chip-list"
                  text-color="white"
                  v-if="form.status"
                >
                  {{
                    $vuetify.lang.t("$vuetify.transferStatus." + form.status)
                  }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.transfer.cols.status.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-scale-balance</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1"
                >{{ form.charges }}
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.transfer.cols.charges.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <v-divider></v-divider>
          <template v-if="$auth.check(['ROLE_ADMIN'])">
            <template v-if="form.error">
              <v-list-item>
                <v-list-item-icon>
                  <v-icon color="secondary">mdi-flag</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="body-1">
                    {{ form.error }}
                  </v-list-item-title>
                  <v-list-item-subtitle
                    >{{ $vuetify.lang.t("$vuetify.transfer.cols.error.title") }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="secondary">mdi-hexagon-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1">
                  <json-viewer :value="form.data" boxed copyable></json-viewer>
                </v-list-item-title>
                <v-list-item-subtitle
                  >{{ $vuetify.lang.t("$vuetify.transfer.cols.data.title") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </template>
          <v-list-item>
            <v-list-item-icon>
              <v-icon color="secondary">mdi-calendar</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title class="body-1"
                >{{ form.createdAt }}
              </v-list-item-title>
              <v-list-item-subtitle
                >{{ $vuetify.lang.t("$vuetify.transfer.cols.created.title") }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <template
            v-if="$auth.check(['ROLE_ADMIN', 'ROLE_COMMERCIAL', 'ROLE_COMPTA'])"
          >
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="secondary">mdi-calendar</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1"
                  >{{ form.expiredAt }}
                </v-list-item-title>
                <v-list-item-subtitle
                  >{{ $vuetify.lang.t("$vuetify.transfer.cols.expired.title") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="secondary">mdi-account-multiple-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1"
                  >{{ form.user }}
                </v-list-item-title>
                <v-list-item-subtitle
                  >{{ $vuetify.lang.t("$vuetify.transfer.cols.user.title") }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="secondary">mdi-pound</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1"
                  >{{ form.identifier }}
                </v-list-item-title>
                <v-list-item-subtitle
                  >{{
                    $vuetify.lang.t("$vuetify.transfer.cols.identifier.title")
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-icon>
                <v-icon color="secondary">mdi-pound</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="body-1"
                  >{{ form.remoteIdentifier }}
                </v-list-item-title>
                <v-list-item-subtitle
                  >{{
                    $vuetify.lang.t(
                      "$vuetify.transfer.cols.remoteIdentifier.title"
                    )
                  }}
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="dialog.shows.showDetail = false" text
          >{{ $vuetify.lang.t("$vuetify.btn.close") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Object,
      default: function() {
        return {
          title: "$vuetify.transfer.filter.title",
          shows: {
            showDetail: false
          },
          saveBtnTitle: "$vuetify.btn.save",
          action: "filter"
        };
      }
    },
    form: {
      type: Object,
      default: function() {
        return {
          user: null,
          identifier: null,
          remoteIdentifier: null,
          application: null,
          accountNumber: null,
          invoiceId: null,
          amount: null,
          charges: null,
          reference: null,
          remoteReference: null,
          transaction: null,
          operation: null,
          error: null,
          data: null,
          status: null,
          expiredAt: null,
          createdAt: null
        };
      }
    }
  },
  data: () => ({
    menus: {
      start: false,
      end: false
    },
    loadingBtn: false
  }),
  methods: {
    setForm(item) {
      this.form.identifier = item.identifier;
      this.form.remoteIdentifier = item.remoteIdentifier;
      this.form.application = item.application.name;
      if (item.application.user)
        this.form.user = item.application.user.username;
      this.form.accountNumber = item.accountNumber;
      this.form.invoiceId = item.invoiceId;
      this.form.amount = item.amount;
      this.form.charges = item.charges;
      this.form.reference = item.reference ? item.reference : " - ";
      this.form.remoteReference = item.remoteReference
        ? item.remoteReference
        : " - ";
      this.form.transaction = item.type;
      this.form.data = item.data;
      this.form.error = item.error ? item.error.description : null;
      this.form.operation = this.$vuetify.lang.t(
        "$vuetify.paymentOperations." + item.operation
      );
      this.form.status = item.status;
      this.form.createdAt = this.$moment(item.createdAt).format(
        "YYYY-MM-DD HH:mm:ss"
      );
      this.form.expiredAt = this.$moment(item.expiredAt).format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    getTypeColor(type) {
      switch (type) {
        case "OM":
          return "orange darken-1";
        case "MOMO":
          return "yellow darken-2";
        case "EUM":
          return "blue darken-2";
        default:
          return "secondary";
      }
    },
    getStatusColor(status) {
      switch (status) {
        case "NEW":
          return "primary";
        case "PENDING":
          return "purple";
        case "ERROR":
          return "red darken-4";
        case "CANCEL":
          return "red darken-1";
        case "TIMEOUT":
          return "pink darken-1";
        case "SUCCESS":
          return "teal accent-4";
        default:
          return "primary";
      }
    }
  }
};
</script>

<style scoped>
>>> .v-list-item__title {
  white-space: initial;
}

.jv-container.jv-light {
  font-size: 12px !important;
  font-family: "Lato", sans-serif !important;
}

.jv-container.jv-light .jv-item.jv-string {
  color: #1d46d2;
}
</style>
